import { HTMLContent } from './HTMLContent'

export class Image extends HTMLContent {
  parse() {
    let { url, alt, dimensions, copyright: caption } = this.content
    this.content = { url, alt, caption, width: dimensions.width }

    return this
  }
}



// WEBPACK FOOTER //
// ./src/api/classes/Image.js